import { useState, useEffect, useReducer, useContext, useCallback } from "react";
import toastError from "../../errors/toastError";

import api from "../../services/api";
import { SocketContext } from "../../context/Socket/SocketContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_WHATSAPPS") {
    const whatsApps = action.payload;

    return [...whatsApps];
  }

  if (action.type === "UPDATE_WHATSAPPS") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex] = whatsApp;
      return [...state];
    } else {
      return [whatsApp, ...state];
    }
  }

  if (action.type === "UPDATE_SESSION") {
    const whatsApp = action.payload;
    const whatsAppIndex = state.findIndex((s) => s.id === whatsApp.id);

    if (whatsAppIndex !== -1) {
      state[whatsAppIndex].status = whatsApp.status;
      state[whatsAppIndex].updatedAt = whatsApp.updatedAt;
      state[whatsAppIndex].qrcode = whatsApp.qrcode;
      state[whatsAppIndex].retries = whatsApp.retries;
      return [...state];
    } else {
      return [...state];
    }
  }

  if (action.type === "DELETE_WHATSAPPS") {
    const whatsAppId = action.payload;

    const whatsAppIndex = state.findIndex((s) => s.id === whatsAppId);
    if (whatsAppIndex !== -1) {
      state.splice(whatsAppIndex, 1);
    }
    return [...state];
  }

  if (action.type === "RESET") {
    return [];
  }
};

const useWhatsApps = () => {
  const [whatsApps, dispatch] = useReducer(reducer, []);
  const [loading, setLoading] = useState(true);

  const socketManager = useContext(SocketContext);

  const fetchSession = useCallback(async (silent = false) => {
    if (!silent) {
      setLoading(true);
    }

    try {
      const { data } = await api.get("/whatsapp/?session=0");
      dispatch({ type: "LOAD_WHATSAPPS", payload: data });
    } catch (err) {
      if (!silent) {
        toastError(err);
      }
    } finally {
      if (!silent) {
        setLoading(false);
      }
    }
  }, []);

  useEffect(() => {
    fetchSession();
  }, [fetchSession]);

  useEffect(() => {
    const refreshOnFocus = () => {
      if (document.visibilityState === "visible") {
        fetchSession(true);
      }
    };

    const refreshInterval = setInterval(() => {
      fetchSession(true);
    }, 10000);

    document.addEventListener("visibilitychange", refreshOnFocus);

    return () => {
      clearInterval(refreshInterval);
      document.removeEventListener("visibilitychange", refreshOnFocus);
    };
  }, [fetchSession]);

  useEffect(() => {
    const companyId = localStorage.getItem("companyId");
    const socket = socketManager.getSocket(companyId);

    const handleWhatsAppEvent = data => {
      if (data.action === "update") {
        dispatch({ type: "UPDATE_WHATSAPPS", payload: data.whatsapp });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_WHATSAPPS", payload: data.whatsappId });
      }
    };

    const handleWhatsAppSessionEvent = data => {
      if (data.action === "update") {
        dispatch({ type: "UPDATE_SESSION", payload: data.session });
      }
    };

    socket.on(`company-${companyId}-whatsapp`, handleWhatsAppEvent);
    socket.on(`company-${companyId}-whatsappSession`, handleWhatsAppSessionEvent);

    return () => {
      socket.off(`company-${companyId}-whatsapp`, handleWhatsAppEvent);
      socket.off(`company-${companyId}-whatsappSession`, handleWhatsAppSessionEvent);
    };
  }, [socketManager]);

  return { whatsApps, loading };
};

export default useWhatsApps;
